import Entity from './Entity';

import PositionedEffect from './PositionedEffect';

import ImageUrlHelper, {Options} from '../helpers/ImageUrlHelper';

export default class Effect implements Entity {
  constructor(
    public id: number,
    public baseEffectId: number,
    public name: string,
    public originalImageUrl: string,
    public centerPositionedEffect: PositionedEffect,
  ) {}

  public getImageUrl(options: Options): string {
    return ImageUrlHelper.getImageUrl(this.originalImageUrl, options);
  }
}
